import { Box } from "@mui/material";
import React from "react";

export const Logo = ({ height, width, sx, ...props }) => {
  return (
    <Box
      component="svg"
      viewBox="0 0 2125.98 1024"
      sx={{
        height,
        width,
        path: {
          fill: (theme) => theme.palette.primary.light,
          stroke: (theme) => theme.palette.grey[900],
          strokeWidth: 30,
          strokeMiterlimit: 10,
        },
        ...sx,
      }}
      {...props}
    >
      <path d="M328.77 644.62l-72.88-3L251.71 858q-88.61 8.89-111.51 8.89t-25.89-2q.6-17.77 1-52.85l.6-83q1-69.14 5.57-576.84a1500.93 1500.93 0 01212.27-14.81q75.47 0 116.09 52.35 52.56 68.16 52.36 208.91 0 245.97-173.43 245.97zM360 395.22q0-45.93-12.84-55.31t-35.25-9.39q-22.4 0-50.87 7.41-2.79 77.55-2.79 134.83 3.18 3 41.82 3 59.93-.04 59.93-80.54zM543.82 522.14q0-188.64 61.62-289.9T776.2 131q109.13 0 168.65 93.83t59.54 265.71q0 186.19-63.12 290.14t-172.44 104q-109.32 0-167.16-96.55t-57.85-265.99zm230.39 162q35 0 53.66-46.92t18.62-139q0-92.1-18.92-127.17T775.4 336q-33.25 0-52.66 45.69t-19.42 132.6q0 169.86 70.89 169.84zM1367.08 870.82l-51-340.77L1285 782.41l-11.35 83.47q-35.85 4.92-133.81 4.94l-99.36-600.55L1024 146.8l97-7.41 51.77-3 46.4 374.85 44.4-364.48 109.12-4.44L1425 486.58l44.6-340.77 133.4-3.45-113.9 718.58q-10.76 3-55.65 6.42t-66.37 3.46z" />
      <path d="M1665.88 728.57l185.27 13.82q-7.74 71.05-23.54 196.45-3.88.84-186.7-8.16zM1727 81.39l294.28 12.42-186 547.69-129-6.36 7.23-537.21q1.23-17.14 13.49-16.54z" />
    </Box>
  );
};
